import {
  formatDateDisplay,
  formatTime12h,
  formatWorkingHours,
  SOURCE_NOTES,
} from '../constants/hrmsAttendanceDetails.constants'
import type { StaffAttendanceRecord } from '../types/hrmsAttendanceRecords.types'
import { AttendanceRecordStatusBadge } from './AttendanceRecordStatusBadge'
import { AttendanceSourceBadge } from './AttendanceSourceBadge'

interface AttendanceDetailsCardProps {
  record: StaffAttendanceRecord
  selectedDate: string
}

export function AttendanceDetailsCard({ record, selectedDate }: AttendanceDetailsCardProps) {
  const isLate = record.status === 'Late'
  const sourceNote = (record.source && (SOURCE_NOTES as Record<string, string>)[record.source]) || SOURCE_NOTES.None

  return (
    <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-xs space-y-3 min-w-0">
      <div className="flex items-center justify-between gap-2 border-b border-slate-100 pb-2.5">
        <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
          ATTENDANCE DETAILS
        </span>
        <span className="text-xs font-bold text-slate-900">{formatDateDisplay(selectedDate)}</span>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <div className="text-xs text-slate-500">Check In</div>
          <div className={`text-sm font-bold mt-0.5 ${isLate ? 'text-amber-700' : 'text-slate-900'}`}>
            {formatTime12h(record.checkIn)}
          </div>
        </div>

        <div>
          <div className="text-xs text-slate-500">Check Out</div>
          <div className="text-sm font-bold text-slate-900 mt-0.5">
            {formatTime12h(record.checkOut)}
          </div>
        </div>

        <div>
          <div className="text-xs text-slate-500">Working Hours</div>
          <div className="text-sm font-bold text-slate-900 mt-0.5">
            {formatWorkingHours(record.workingMinutes)}
          </div>
        </div>

        <div>
          <div className="text-xs text-slate-500">Status</div>
          <div className="mt-1">
            <AttendanceRecordStatusBadge status={record.status} />
          </div>
        </div>
      </div>

      <div className="border-t border-slate-100 pt-2.5 space-y-1">
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs text-slate-500">Source</span>
          <AttendanceSourceBadge source={record.source} />
        </div>
        <p className="text-xs text-slate-500 mt-1">{sourceNote}</p>
      </div>
    </div>
  )
}
